import { Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import {
  FormContainer,
  FormInput,
  SwitchInput,
  Treturn,
  useFetch,
} from "@4uhub/lib4uhub";
import { memo, useCallback, useState } from "react";
import FormInformation from "../../../../../components/FormInformation/FormInformation";
import {
  createTicketFinishReason,
  getTicketFinishReasonById,
  updateTicketFinishReasonById,
} from "../../../../../services/ticketFinishReason.service";
import {
  ticketFinishReasonSchema,
  TTicketFinishReasonForm,
} from "./ticketFinishReasonSchema";

const translationPath = "chatBot.page.service.ticketFinishReason.";

export const TicketFinishReason = memo(() => {
  const { t } = useTranslation();

  const [code, setCode] = useState<string>();

  const { sendRequest: save, loading: sLoading } = useFetch(
    createTicketFinishReason
  );

  const { sendRequest: update, loading: uLoading } = useFetch(
    updateTicketFinishReasonById
  );

  const { sendRequest: get, loading: gLoading } = useFetch(
    getTicketFinishReasonById
  );

  const saveHandler = useCallback(
    async (v: TTicketFinishReasonForm) => {
      return save({ ...v, enable: v.enable, name: v.name });
    },
    [save]
  );

  const updateHandler = useCallback(
    async (v: TTicketFinishReasonForm, id: string) => {
      return update({
        item: {
          id,
          ...v,
          enable: v.enable,
          name: v.name,
        },
        id,
      });
    },
    [update]
  );

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TTicketFinishReasonForm>> => {
      console.log(id);
      const { data, success } = await get(id);
      if (data) {
        setCode(data.code);
        const newData: TTicketFinishReasonForm = {
          ...data,
          name: data.name,
          enable: data.enable,
        };
        return { data: newData, success: true };
      }
      return { data, success };
    },
    [get]
  );

  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TTicketFinishReasonForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      loading={loading}
      title={t(translationPath + "ticket_finish_reason")}
      schema={ticketFinishReasonSchema}
      subtitle={t(translationPath + "new_ticket_finish_reason")}
      subtitleWatchField={"name"}
      fields={(type) => (
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            display={"flex"}
            justifyContent={type === "create" ? "end" : "space-between"}
            alignItems={"center"}
          >
            {type === "update" && (
              <FormInformation
                label={t(translationPath + "code")}
                data={code ?? "-"}
                minHeight={40}
              />
            )}

            <SwitchInput name="enable" label={t(translationPath + "enable")} />
          </Grid>

          <Grid item xs={12} sm={12}>
            <FormInput
              size="small"
              name="name"
              label={t(translationPath + "name")}
              autoFocus
              fullWidth
              maxLength={255}
            />
          </Grid>
        </Grid>
      )}
    />
  );
});
